export interface IntegralV2MetricGradeModel {
  hr: string;
  singleHr: string;
}

export class IntegralV2MetricModel {
  ag?: string[];
  d!: number;
  global!: IntegralV2MetricGradeModel;
  rg!: number;
  val!: string | number;
  ver?: string;
  /**
   * Contains calculated value for radar,
   * value in range in between 0 and 1
   */
  gmc!: number;
  shape!: IntegralV2MetricGradeModel;
  /**
   * Contains calculated value for radar of shape normalized metric,
   * value in range in between 0 and 1
   */
  smc!: number;
}

export default class IntegralV2Metric extends IntegralV2MetricModel {
  constructor({ ag, d, global, rg, val, ver, gmc, shape, smc }: IntegralV2MetricModel) {
    super();

    this.ag = ag;
    this.d = d;
    this.global = global;
    this.rg = rg;
    this.val = Number(val).toFixed(2);
    this.ver = ver;
    this.gmc = gmc;
    this.shape = shape;
    this.smc = smc;
  }
}
